function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FFFFFF;}.cls-4,.cls-5{fill:#FFFFFF;}.cls-2,.cls-3{fill:#FFFFFF;}.cls-2{opacity:0.7;}.cls-4{opacity:0.65;}.cls-5{font-size:8.85px;font-family:Champagne &amp; Limousines;font-weight:700;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M357.12,401.37a12.13,12.13,0,1,0,8.58,3.55A11.73,11.73,0,0,0,357.12,401.37Zm10.18,12.12a10.18,10.18,0,1,1-3-7.18A9.85,9.85,0,0,1,367.3,413.49Z",
  transform: "translate(-225,-395)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M288,403.39a9.83,9.83,0,0,1,6.31,2.19,1,1,0,0,0,1.59-.79,1,1,0,0,0-.37-0.75,12.1,12.1,0,1,0,0,19,1,1,0,0,0,.37-0.75,1,1,0,0,0-.33-0.75h0a1,1,0,0,0-1.26,0A10.14,10.14,0,1,1,288,403.39Z",
  transform: "translate(-225,-395)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M309.55,401.37a12.13,12.13,0,1,0,8.58,3.55A11.73,11.73,0,0,0,309.55,401.37Zm10.18,12.12a10.18,10.18,0,1,1-3-7.18A9.85,9.85,0,0,1,319.73,413.49Z",
  transform: "translate(-225,-395)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M342,414.37a1,1,0,0,0-1,1v5.78a0.71,0.71,0,0,1-.07.71,9.4,9.4,0,0,1-5.72,1.84,9.65,9.65,0,0,1-7.1-3,10.17,10.17,0,0,1,13.56-15.1,1,1,0,0,0,1.24,0l0,0a1,1,0,0,0,.33-0.74,1,1,0,0,0-.35-0.72,12.11,12.11,0,1,0-7.56,21.55,10.65,10.65,0,0,0,7.38-2.85,1.37,1.37,0,0,0,.26-1.14v-6.3A1,1,0,0,0,342,414.37Z",
  transform: "translate(-225,-395)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M256.36,413.93a10.61,10.61,0,0,0-14.69,3c-4,6-2,20.15-1.92,20.75a1,1,0,0,0,1.18.79c0.58-.15,14.37-3.77,18.38-9.81A10.61,10.61,0,0,0,256.36,413.93Z",
  transform: "translate(-220.19 -401.37)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M222,428.62c4,6,17.8,9.65,18.38,9.81a1,1,0,0,0,1.18-.79c0.09-.6,2.09-14.71-1.92-20.75A10.59,10.59,0,0,0,222,428.62Z",
  transform: "translate(-220.19 -401.37)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M240.64,401.46A10.61,10.61,0,0,0,230,412.05c0,7.25,9.48,17.89,9.88,18.34a1,1,0,0,0,1.42,0c0.4-.45,9.88-11.09,9.88-18.34A10.61,10.61,0,0,0,240.64,401.46Z",
  transform: "translate(-220.19 -401.37)"
});

var SvgCogoLogo = function SvgCogoLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 149.57 38.66",
    style: {
      backgroundColor: "#27AAE1"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCogoLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cogo_logo.899c37d9.svg";
export { ForwardRef as ReactComponent };